import { apiSlice } from '../api/apiSlice';

export const serviceApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getServiceDetail: builder.query({
      query: (id) => ({
        url: `/service/id/?id=${id}`,
      }),
      providesTags: (result, error, id) => [{ type: 'UserServices', id }],
    }),
    createService: builder.mutation({
      query: (data) => ({
        url: '/service/',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['UserServices'],
    }),
    updateService: builder.mutation({
      query: ({ id, data }) => ({
        url: `/service/id/?id=${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'UserServices', id },
        'UserServices'
      ],
    }),
    deleteService: builder.mutation({
      query: (id) => ({
        url: `/service/?id=${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['UserServices'],
    }),
    getFilteredServices: builder.query({
      query: (arg) => {
        if (typeof arg === "string") {
          const qs = arg ? (arg.startsWith("?") ? arg : `?${arg}`) : "";
          return `/service/filter${qs}`;
        }
        return {
          url: "/service/filter",
          params: arg || {},
        };
      },
      providesTags: ["FilteredServices"],
    }),
    getServicesByUserAndCategory: builder.query({
      query: (params) => ({
        url: `/service/user/`,
        params,
      }),
    }),
    getCertExpeSer: builder.query({
      query: ({ serviceid, type, id }) => ({
        url: `/service/GetCertExpeSer/id/?id=${serviceid}${type === "service" ? `&servicesid=${id}` : `&experienceid=${id}`}`,
      }),
    }),
  }),
});

export const {
  useGetServiceDetailQuery,
  useCreateServiceMutation,
  useUpdateServiceMutation,
  useDeleteServiceMutation,
  useGetFilteredServicesQuery,
  useLazyGetFilteredServicesQuery,
  useGetServicesByUserAndCategoryQuery,
  useLazyGetServicesByUserAndCategoryQuery,
  useGetCertExpeSerQuery,
} = serviceApiSlice;
